(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

// Create Cookie for n seconds
function storeCookie(name, value) {
  var seconds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  var date = new Date();
  date.setTime(date.getTime() + seconds * 1000);
  var expires = "; expires=" + date.toGMTString();
  document.cookie = name + "=" + value + expires + "; path=/";
} // Get Cookie by name


function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}

jQuery(document).ready(function ($) {
  if (localStorage.getItem('currentUserWeb') == null && getCookie('user') == '') {
    $(".input-text").keyup(function () {
      var current_value = $(this).val();
      var current_id = $(this).attr('id');

      if (current_value != '') {
        storeCookie(current_id, current_value, 600);
      } else {
        storeCookie(current_id, '', 1);
      }
    });
    $("input[name='delivery_hour_on']").change(function () {
      var current_value = $(this).val();
      var current_id = $(this).attr('id');
      console.log(current_value, 'current_value');
      console.log(current_id, 'current_id');

      if (current_value == 'now') {
        storeCookie(current_id, current_value, 600);
        storeCookie('delivery_hour_on_choose_date', '', 1);
        storeCookie('delivery_hour', '', 1);
      } else {
        storeCookie(current_id, current_value, 600);
        storeCookie('delivery_hour_on_now', '', 1);
      }
    });
    $('#delivery_hour').on('change', function (e) {
      var current_value = this.value;
      console.log(current_value, 'delivery_hour');

      if (current_value != '') {
        storeCookie('delivery_hour', current_value, 600);
      } else {
        storeCookie('delivery_hour', '', 1);
      }
    });

    if (getCookie('billing_first_name') != '') {
      $('#billing_first_name').val(getCookie('billing_first_name'));
    }

    if (getCookie('billing_last_name') != '') {
      $('#billing_last_name').val(getCookie('billing_last_name'));
    }

    if (getCookie('billing_address_1') != '') {
      $('#billing_address_1').val(getCookie('billing_address_1'));
    }

    if (getCookie('billing_city') != '') {
      $('#billing_city').val(getCookie('billing_city'));
    }

    if (getCookie('billing_email') != '') {
      $('#billing_email').val(getCookie('billing_email'));
    }

    if (getCookie('billing_phone') != '') {
      $('#billing_phone').val(getCookie('billing_phone'));
    }

    if (getCookie('order_comments') != '') {
      $('#order_comments').val(getCookie('order_comments'));
    }

    if (getCookie('billing_bloc') != '') {
      $('#billing_bloc').val(getCookie('billing_bloc'));
    }

    if (getCookie('billing_apartament') != '') {
      $('#billing_apartament').val(getCookie('billing_apartament'));
    }

    if (getCookie('billing_scara') != '') {
      $('#billing_scara').val(getCookie('billing_scara'));
    }

    if (getCookie('billing_etaj') != '') {
      $('#billing_etaj').val(getCookie('billing_etaj'));
    }

    if (getCookie('delivery_hour_on_choose_date') != '') {
      setTimeout(function () {
        $('#delivery_hour_on_choose_date').trigger('click');
      }, 500);
    }

    if (getCookie('delivery_hour_on_now') != '') {
      setTimeout(function () {
        $('#delivery_hour_on_now').trigger('click');
      }, 500);
    }

    if (getCookie('delivery_hour') != '') {
      setTimeout(function () {
        $('#delivery_hour option[value="' + getCookie('delivery_hour') + '"]').prop('selected', true);
      }, 500);
    }
  }
});

},{}]},{},[1]);
